import useHeaderStore from '@/store/header';

/**
 * Shared modal-session ids (division / district / thana).
 *
 * Backed by `useHeaderStore` (Zustand) so every consumer reads and writes the
 * same slice. Setters are stable references from Zustand, so the consumer-side
 * dep arrays stay clean. The values are session-scoped and intentionally not
 * added to the `partialize` whitelist — they should reset across page reloads
 * (modal-local UI state, not user preference).
 */
export const useLocationIds = () => {
  const divisionId = useHeaderStore((state) => state.divisionId);
  const districtId = useHeaderStore((state) => state.districtId);
  const thanaId = useHeaderStore((state) => state.thanaId);
  const setDivisionId = useHeaderStore((state) => state.setDivisionId);
  const setDistrictId = useHeaderStore((state) => state.setDistrictId);
  const setThanaId = useHeaderStore((state) => state.setThanaId);

  return {
    divisionId,
    districtId,
    thanaId,
    setDivisionId,
    setDistrictId,
    setThanaId,
  };
};
